<template>
  <div class="vacancy-item__main-actions  _no-link">
    <AccountMyVacanciesItemMainActionsRespond :vacancy="vacancy"
                                              @responded="$emit('responded', $event)"/>


    <div class="vacancy-item__btn-wrap  _bookmark-more  _no-link">
      <router-link-modified :to="{
                                  name: 'vacancy',
                                  params: {
                                    vacancyId: this.vacancy[1].slug
                                  }
                                }"
                            class="vacancy-item__more">
        {{ $tVacancy('More details') }}
        <BaseSvg name="ico-arrow-light"/>
      </router-link-modified>
    </div>

    <div v-if="pendingBookmarks"
         class="vacancy-item__toggle-bookmarks  _active">
      <BaseSvg name="ico-trash"/>
      <BasePreloader class="_small"/>
    </div>
    <button v-else
            @click.prevent="toggleBookmarks"
            class="vacancy-item__toggle-bookmarks">
      <BaseSvg name="ico-trash"/>
    </button>
  </div>
</template>

<script>
  import {http} from '@/axios'
  import AccountMyVacanciesItemMainActionsRespond from './AccountMyVacanciesItemMainActionsRespond'

  export default {
    name: 'AccountMyVacanciesItemMainActions',
    components: {
      AccountMyVacanciesItemMainActionsRespond
    },
    props: {
      vacancy: Object
    },
    data() {
      return {
        pendingBookmarks: false
      }
    },
    methods: {
      toggleBookmarks() {
        if (this.pendingBookmarks) return
        this.pendingBookmarks = true

        http.post(`/api/new-vacancy/set-to-bookmarks/${this.vacancy.ID}`).then(({data}) => {
          this.$emit('bookmark', data.data === 'SET')

          if (data.data === 'SET') {
            this.$vModal.open('saved-to-favorites', {
              bookmarksQuantity: data.bookmarks_count
            })
          }

          this.$store.commit('user/setProperty', ['bookmarksCount', data.bookmarks_count])
        }).finally(() => {
          this.pendingBookmarks = false
        })
      },
      onRespond() {

      }
    }
  }
</script>

<style lang="less">

</style>
